import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { FaSearch, FaTimes } from "react-icons/fa";
import { setGlobalUserFilter } from "../../store/slices/adminSlice";
import {
  SearchBtn,
  SearchIconWrap,
  SearchInput,
  SearchWrap,
} from "../../components/Admins/UserTableStyles";

export const UserFilter = ({ handleSearch, handleClose }) => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const filters = JSON.parse(localStorage.getItem("filterUsers") || "{}");
  const [typeFilter, setTypeFilter] = useState(filters.typeFilter || "");

  const handleChange = (e) => {
    const val = e.target.value;
    setTypeFilter(val);
    dispatch(setGlobalUserFilter({ typeFilter: val }));
  };

  const handleClear = () => {
    setTypeFilter("");
    dispatch(setGlobalUserFilter({ typeFilter: "" }));
    handleSearch(true);
    inputRef.current?.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSearch(false);
  };

  return (
    <SearchWrap>
      <SearchIconWrap>
        <FaSearch size={16} />
      </SearchIconWrap>

      <SearchInput
        ref={inputRef}
        type="text"
        value={typeFilter}
        placeholder="Search by name or email…"
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        autoComplete="off"
      />

      {typeFilter && (
        <button
          onClick={handleClear}
          style={{
            background: "none",
            border: "none",
            padding: "0 10px",
            cursor: "pointer",
            color: "#94a3b8",
            display: "flex",
            alignItems: "center",
            flexShrink: 0,
          }}
          aria-label="Clear search"
        >
          <FaTimes size={13} />
        </button>
      )}

      <SearchBtn onClick={() => handleSearch(false)}>
        <FaSearch size={13} />
        Search
      </SearchBtn>
    </SearchWrap>
  );
};
